import { shareUrl, language } from '../constants';
import { LANGUAGE_KEYS_MAP, SHORT_LINK_REDIRECT_MAP } from '../middleware/short-link-handler';

const stripProtocol = str => {
  const protocolEnd = str.indexOf('://');
  if (protocolEnd !== -1) {
    return str.substr(protocolEnd + 3);
  }
  return str;
};

const makeSharingUrl = (route, lang = language.default, base = shareUrl, returnFullUrl = false) => {
  const parts = route.split('/').filter(p => p);
  const short = parts.length && SHORT_LINK_REDIRECT_MAP[parts[0]];
  let locale = lang === language.default ? '' : lang || '';

  if (short && !returnFullUrl) {
    parts[0] = short;
    locale = (locale && LANGUAGE_KEYS_MAP[locale]) || '';
    return stripProtocol(`${base}/${locale}${parts.join('/')}`);
  }

  locale = locale && `/${locale}`;
  return `${base}${locale}${route}`;
};

export default makeSharingUrl;
